import { UIViewController, UITableView, UITableViewDatasource, UITableViewDelegate, UITableViewCell, UILabel } from "uikit"
import { IndexPath } from "foundation"
import { DLDB, CartLine, Cart } from "dldb"
import { BookingReviewCell, BookingReviewCellDelegate } from "./BookingReviewCell";


export class BookingProductReviewViewController extends UIViewController implements UITableViewDatasource, UITableViewDelegate, BookingReviewCellDelegate
{
    private tableView: UITableView;
    private subTotalLabel: UILabel;
    private discountLabel: UILabel;
    private totalLabel: UILabel;

    private cart:Cart = DLDB.shared.cart();

    viewDidLoad() {
        super.viewDidLoad();

        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.tableView.reloadData();
        this.updateTotals();
    }

    viewWillAppear(animated: boolean): void {
        super.viewWillAppear(animated);
        this.cart.addObserver ( this, "lines", null );
    }

    viewWillDisappear(animated: boolean): void {
        super.viewWillDisappear(animated);
        this.cart.removeObserver ( this, "lines" );
    }

    observeValueForKeyPath(keyPath: string, type: string, object: any, context: any): void {
        if ( keyPath === "lines" && type != "did") return;
        this.tableView.reloadData();
        this.updateTotals();
    }

    numberOfSections(tableView: UITableView) {
        return 1;
    }

    numberOfRowsInSection(tableView: UITableView, section: number): number {
        return DLDB.shared.cart().lines.length;
    }

    cellForRowAt(tableView: UITableView, indexPath: IndexPath): UITableViewCell {
        let cell = tableView.dequeueReusableCellWithIdentifier( "BookingReviewCell" ) as BookingReviewCell;
        cell.item = DLDB.shared.cart().lines[ indexPath.row ];
        cell.delegate = this;
        return cell;
    }

    didSelectCellAtIndexPath ( tableView: UITableView, indexPath: IndexPath ){
    }

    updateTotals ( ) {
        this.subTotalLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( DLDB.shared.cart().subTotal );
        this.discountLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( DLDB.shared.cart().discount );
        this.totalLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( DLDB.shared.cart().total );
    }

    onProductDidChange ( cell: BookingReviewCell, numberOfProducts:number, line: CartLine ) {
        DLDB.shared.cart().updateProductQuantity( line.productID, line.productName, line.productPrice, line.quantity + numberOfProducts, [] );
        
        this.tableView.reloadData();

        this.subTotalLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( DLDB.shared.cart().subTotal );
        this.discountLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( DLDB.shared.cart().discount );
        this.totalLabel.text = DLDB.shared.currencyFormatter().stringFromNumber( DLDB.shared.cart().total );
    }
}